/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Extend({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M5.647 8.019h4.745M7.98 10.354V5.61" /><circle cx={12.608} cy={3.391} r={1.851} stroke="currentColor" strokeWidth={1.2} /><circle cx={12.608} cy={12.646} r={1.851} stroke="currentColor" strokeWidth={1.2} /><circle cx={3.353} cy={3.391} r={1.851} stroke="currentColor" strokeWidth={1.2} /><circle cx={3.353} cy={12.646} r={1.851} stroke="currentColor" strokeWidth={1.2} /></svg>;
}
;